/**
 * Usage Scenarios Section
 * Handles mobile swiper functionality
 */

class UsageScenarios {
  constructor(container) {
    this.container = container || document.querySelector('.w-usage-scenarios');

    if (!this.container) return;

    this.swiper = null;
    this.swiperContainer = this.container.querySelector('.w-usage-scenarios__cards');
    this.resizeTimer = null;

    this.init();
  }

  init() {
    this.initSwiper();
    this.initResizeListener();
  }

  initSwiper() {
    const isMobile = window.innerWidth < 990;

    if (!this.swiperContainer) return;

    if (isMobile && !this.swiper) {
      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 18,
        loop: false,
        grabCursor: true,
        touchRatio: 1,
        resistanceRatio: 0.85,
        centeredSlides: false,
      });
    } else if (!isMobile && this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initResizeListener() {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.initSwiper();
      }, 250);
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
  const usageScenariosSection = document.querySelector('.w-usage-scenarios');
  if (usageScenariosSection) {
    new UsageScenarios(usageScenariosSection);
  }
});

// Expose class globally for dynamic initialization
window.UsageScenarios = UsageScenarios;
